/**
 * Centralised icon registry — all Lucide icons used by the app.
 * Never import icons directly in components; use this map instead.
 * To swap the icon set: update imports and right-hand sides here only.
 */

import {
  Satellite,
  Map,
  Settings,
  LogOut,
  User,
  Navigation,
  Eye,
  EyeOff,
  ZoomIn,
  ChevronLeft,
  ChevronRight,
  Car,
  MapPin,
  Target,
  Flag,
  Crosshair,
  ExternalLink,
  RefreshCw,
  RotateCcw,
  Maximize2,
  X,
  Check,
  AlertCircle,
} from 'lucide-react';

export const IconMapping = {
  navbar_selection: Satellite,
  navbar_settings:  Settings,
  navbar_logout:    LogOut,
  navbar_user:      User,

  map_style_street:    Map,
  map_style_satellite: Satellite,
  map_fit_all:         Maximize2,
  map_my_location:     Navigation,
  map_refresh:         RefreshCw,

  panel_collapse:        ChevronRight,
  panel_expand:          ChevronLeft,
  panel_close_tab:       X,
  panel_flight_visible:  Eye,
  panel_flight_hidden:   EyeOff,
  panel_zoom_balloon:    Crosshair,
  panel_zoom_normal:     MapPin,
  panel_zoom_instant:    MapPin,
  panel_zoom_trajectory: Maximize2,
  panel_back_to_last:    RotateCcw,
  panel_teams_toggle:    Car,

  marker_current: MapPin,   // last-known / current position — pin anchored at bottom
  marker_start:   Target,   // departure / takeoff position — target centered
  marker_landing: Flag,     // landing prediction — flag inside colored badge
  marker_team:    Car,

  badge_active:     Check,
  badge_historical: AlertCircle,

  prediction_gmaps: ExternalLink,

  settings_reset_color: X,

  _zoom_in: ZoomIn,
} as const;

export type IconKey = keyof typeof IconMapping;
